/**
 * api-surumu.ts
 *
 * NE İŞE YARAR : API yol önekini tek yerde tutar — `/api/v1`
 * KAYNAK SPEC  : ADR-013 A5 (*"API sürümleme baştan var"*) · 04-api-sozlesmesi.md §2.11
 *                docs/standartlar/05-api-ve-entegrasyon.md
 * BAĞLI OLDUĞU : — (saf sabit)
 * KULLANAN     : src/main.ts (`setGlobalPrefix`) · arayuz/vite.config.ts (vekil hedefi)
 *                test/src/g22-api-surumu.spec.ts (kapı G22)
 * DİKKAT       : 1) ÖNEK **TAŞIMA KATMANINDADIR**, sözleşmede değil. `04` §4 yolları
 *                   öneksiz yazar (`/students`) çünkü önek her uca aynı biçimde
 *                   uygulanır; sözleşmeye yazılsaydı 120 satırda 120 kez tekrarlanır ve
 *                   sürüm değiştiğinde 120 satır düzeltilirdi.
 *                2) TESTLER ÖNEKSİZ ÇAĞIRIR ve bu bilinçlidir. Test modülleri
 *                   denetleyicileri doğrudan monte eder; `main.ts`ten geçmezler.
 *                   Öneki testlere de taşımak, sınanan şeyi (denetleyicinin yolu)
 *                   sınanmayan bir şeyin (açılış yapılandırması) arkasına saklardı.
 *                   Öneğin gerçekten uygulandığını **kapı G22** kaynak taramasıyla
 *                   denetler.
 *                3) SÜRÜM NEDEN ŞİMDİ VAR. Faz 1'de tek istemci arayüzdür ve arka uçla
 *                   aynı anda dağıtılır; sürümün bugün pratik faydası yoktur. Değeri
 *                   Faz 2'de gelir: telefondaki uygulama sunucuyla **aynı anda
 *                   güncellenmez** ve eski sürüm haftalarca eski sözleşmeyi çağırır.
 *                   Öneki sonradan eklemek bütün yolları değiştirir — yani tam olarak
 *                   sürümlemenin önlemek için var olduğu kesintiyi üretir. 51. adım bunu
 *                   yakından gösterdi: 71 ucun başarı kodu değişti ve hiçbir şey
 *                   kırılmadı, **çünkü tek istemci aynı commit'te güncellendi.**
 *                4) `v2` AÇMAK BİR KARAR KAYDI İSTER (ADR-013 Sınıf 4). İki sürüm yan
 *                   yana yaşar; eski sürümün ne zaman kapanacağı kullanımdan kaldırma
 *                   sürecine tabidir (`docs/standartlar/01-degisiklik-ve-risk.md` §4).
 * SON GÜNCELLEME: 2026-08-31 10:20:00
 */

/** Yürürlükteki API sürümü. Değiştirmek ADR-013 Sınıf 4 değişikliğidir. */
export const API_SURUMU = 'v1';

/** Bütün uçların taşıdığı yol öneki — `main.ts` bunu `setGlobalPrefix`e verir. */
export const API_ONEKI = `api/${API_SURUMU}`;
